import React from 'react';
import { TagIcon } from 'lucide-react';
interface ContentChipsProps {
  activeChip: string;
  onChipClick: (chipId: string) => void;
}
const ContentChips: React.FC<ContentChipsProps> = ({
  activeChip,
  onChipClick
}) => {
  const chips = [{
    id: 'all',
    label: 'Alle'
  }, {
    id: 'completed',
    label: 'Voltooid'
  }, {
    id: 'inprogress',
    label: 'In progress'
  }, {
    id: 'notstarted',
    label: 'Niet gestart'
  }, {
    id: 'stress',
    label: 'Stress'
  }, {
    id: 'focus',
    label: 'Focus'
  }, {
    id: 'mindfulness',
    label: 'Mindfulness'
  }, {
    id: 'slaap',
    label: 'Slaap'
  }, {
    id: 'angst',
    label: 'Angst'
  }, {
    id: 'relaties',
    label: 'Relaties'
  }];
  return <div className="flex flex-wrap gap-2 pb-2 overflow-x-auto" data-id="element-307">
      {chips.map(chip => <button key={chip.id} className={`px-3 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap border ${activeChip === chip.id ? 'bg-gray-200 border-gray-400 text-gray-800' : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-50'}`} onClick={() => onChipClick(chip.id)} data-id="element-308">
          {chip.id !== 'all' && chip.id !== 'completed' && chip.id !== 'inprogress' && chip.id !== 'notstarted' && <TagIcon className="w-3 h-3 inline-block mr-1" data-id="element-309" />}
          {chip.label}
        </button>)}
    </div>;
};
export default ContentChips;